import { produce } from "immer";
import { actionFactory, ActionUnion, payloadAction } from "reductser";

import {
  ClinicianManualCapacityV2DataMap,
  ClinicianVolumeDataMap,
} from "../../../app/slot-tool/types";

const actionMap = {
  setClinicianVolumeDataMap: payloadAction<ClinicianVolumeDataMap>(),
  setClinicianManualCapacityDataMap: payloadAction<
    ClinicianManualCapacityV2DataMap
  >(),
};

export const slotToolActions = actionFactory(actionMap, "SLOTTOOL");
export type SlotToolAction = ActionUnion<typeof slotToolActions>;

export interface SlotToolState {
  clinicianVolumeDataMap: ClinicianVolumeDataMap;
  clinicianManualCapacityDataMap: ClinicianManualCapacityV2DataMap;
}

export const DATE_FORMAT = "YYYY-MM-DD";

function getInitialState(): SlotToolState {
  return {
    clinicianVolumeDataMap: {},
    clinicianManualCapacityDataMap: {},
  };
}

const slotToolReducer = (state = getInitialState(), action: SlotToolAction) =>
  produce(state, draft => {
    switch (action.type) {
      case "setClinicianVolumeDataMap": {
        draft.clinicianVolumeDataMap = action.payload;
        return;
      }
      case "setClinicianManualCapacityDataMap": {
        draft.clinicianManualCapacityDataMap = action.payload;
        return;
      }
    }
  });

export default slotToolReducer;
